import React from "react";
import SupplierReviewListContainer from "../../containers/SupplierDetail/SupplierDetailView/SupplierReviewList";
import "../styles.css";

const SupplierReviewList = () => {
  return (
    <div className="app-page-container supplier-review-list-page">
      <SupplierReviewListContainer />
    </div>
  );
};

export default SupplierReviewList;
